import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "./common/resources/fonts/all.min.css";

import App from "./App";

ReactDOM.render(<App />, document.getElementById("app"));
